import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { NgxsActionHelper } from 'app/projects/core/src/lib/services/action.helper';
import { FetchAudience, FetchAudienceFailure, FetchAudienceSuccess } from 'app/library/audience/actions';

@Injectable()
export class AudienceResolver  {
    constructor(private store: Store, private actionHelper: NgxsActionHelper) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        const audienceId = route.params['id'];
        this.store.dispatch([new FetchAudience(audienceId)]);

        return this.actionHelper.race(FetchAudienceSuccess, FetchAudienceFailure);
    }
}
